import { PointsInfoBannerClient } from './PointsInfoBannerClient';
import VariationChangedEvent from '../VariationChangedEvent';
import HtmlCache from '../HtmlCache';
import BenefitToggledEvent from './BenefitToggledEvent';
import type { QBus } from '@otto-ec/global-resources/event-q-bus';
import { serviceLogger } from '../Logger';

const log = serviceLogger.scope('points-info-banner-service');
const variationChangedTopic = 'ft9.up-teaser-info-banner.variationChanged';
export class PointsInfoBannerService {
	private eventBus: QBus;

	private pointsInfoBannerClient: PointsInfoBannerClient;

	private pointsInfoBannerCache: HtmlCache;

	private variationEventCompleted: boolean = false;

	private receivedVariationChangedEvent;

	private handleVariationChange;

	private handleBenefitEvent;

	constructor(eventBus: QBus, pointsInfoBannerClient: PointsInfoBannerClient, pointsInfoBannerCache: HtmlCache) {
		this.eventBus = eventBus;
		this.pointsInfoBannerClient = pointsInfoBannerClient;
		this.pointsInfoBannerCache = pointsInfoBannerCache;
	}

	/*                       */
	registerEventListeners(): Promise<any[]> {
		this.handleVariationChange = this.onVariationChanged.bind(this);
		this.handleBenefitEvent = this.waitFor.bind(this);
		return Promise.all([
			this.eventBus.on(variationChangedTopic, this.handleVariationChange),
			this.eventBus.on('ft9.benefit.active', this.handleBenefitEvent)
		]);
	}

	onTeaserUIReady() {
		this.eventBus.emit(variationChangedTopic, this.receivedVariationChangedEvent);
		this.variationEventCompleted = true;
	};

	onVariationChanged(event: VariationChangedEvent) {
		this.pointsInfoBannerClient.getFromTeaserUI().then((htmlContent) => {
			this.receivedVariationChangedEvent = event;
			this.handleHTMLContentInTargetElementParent(event.targetElement, htmlContent);
			this.eventBus.off(variationChangedTopic, this.handleVariationChange);
			this.eventBus.on('ft9bcn.teaserui.isReady', this.onTeaserUIReady.bind(this));
		}).catch((reason) => {
			log.error(reason);
		});
	}

	waitFor = (event: BenefitToggledEvent) => {
		const intervalId = setInterval(() => {
			if (this.variationEventCompleted) {
				this.eventBus.off('ft9.benefit.active', this.handleBenefitEvent);
				this.eventBus.emit('ft9.benefit.active', event);
				clearInterval(intervalId);
			}
		}, 100);

		setTimeout(() => {
			clearInterval(intervalId);
		}, 4000);
	};

	executeScriptElements(containerElement) {
		const scriptElements = containerElement.querySelectorAll('script');

		Array.from(scriptElements).forEach((scriptElement: HTMLScriptElement) => {
			const clonedElement = document.createElement('script');

			Array.from(scriptElement.attributes).forEach((attribute) => {
				clonedElement.setAttribute(attribute.name, attribute.value);
			});

			clonedElement.text = scriptElement.text;

			scriptElement.parentNode?.replaceChild(clonedElement, scriptElement);
		});
	}

	private handleHTMLContentInTargetElementParent(targetElement: HTMLElement, htmlContent: string) {
		const elementToHoldScripts = document.createElement('div');
		elementToHoldScripts.innerHTML = htmlContent;
		targetElement.parentElement?.insertAdjacentElement('beforeend', elementToHoldScripts);
		this.executeScriptElements(elementToHoldScripts);
	}
}
